export default __webpack_public_path__ + "static/media/ResetFill.0c415cce.svg";